/**
 * Which modifier key this machine speaks.
 *
 * Used ONLY for presentation — the actual hotkey handler accepts both
 * Cmd+K and Ctrl+K everywhere, so a wrong guess here mislabels a hint but
 * never breaks the shortcut.
 */

export function isMac() {
  if (typeof navigator === 'undefined') return false;
  const platform = navigator.userAgentData?.platform ?? navigator.platform ?? '';
  return /mac|iphone|ipad|ipod/i.test(platform);
}

export function shortcutLabel() {
  return isMac() ? '⌘K' : 'Ctrl+K';
}
